export default {
    STORE_DEVICES: 'store_devices',
}
